export const WHEEL500_ZONE_CONFIG = {
  x2: { label: 'x2', multiplier: 2, hex: '#10B981' },
  x3: { label: 'x3', multiplier: 3, hex: '#3B82F6' },
  x5: { label: 'x5', multiplier: 5, hex: '#A855F7' },
  x50: { label: 'x50', multiplier: 50, hex: '#F59E0B' }
}

export const WHEEL500_ZONE_KEYS = ['x2', 'x3', 'x5', 'x50']

export const WHEEL500_WHEEL_LAYOUT = [
  'x50', 'x2', 'x3', 'x5', 'x2', 'x3', 'x2', 'x5', 'x2', 'x3',
  'x2', 'x3', 'x2', 'x5', 'x2', 'x3', 'x2', 'x3', 'x2', 'x5',
  'x2', 'x3', 'x2', 'x5', 'x3', 'x2', 'x2', 'x3', 'x2', 'x5',
  'x3', 'x2', 'x2', 'x3', 'x5', 'x2', 'x3', 'x2', 'x2', 'x3',
  'x5', 'x2', 'x3', 'x2', 'x5', 'x2', 'x3', 'x2', 'x3', 'x2',
  'x5', 'x2', 'x3', 'x2'
]

export const WHEEL500_SECTORS = WHEEL500_WHEEL_LAYOUT.map((zone, index) => ({
  index,
  zone,
  multiplier: Number(String(zone).slice(1) || 0)
}))

export const WHEEL500_EMPTY_SUMS = {
  x2: 0,
  x3: 0,
  x5: 0,
  x50: 0
}

export const WHEEL500_BETTING_STATUSES = ['new', 'started']
export const WHEEL500_SPINNING_STATUS = 'raffle'
export const WHEEL500_RESULT_STATUSES = ['result', 'finished']

export const WHEEL500_SPIN_DEFAULT_MS = 10000

export const getWheel500ZoneMultiplier = (zone) => {
  return Number(String(zone || '').slice(1) || 0)
}

export const isWheel500BettingStatus = (status) => {
  return WHEEL500_BETTING_STATUSES.includes(String(status || '').toLowerCase())
}

export const isWheel500ResultStatus = (status) => {
  return WHEEL500_RESULT_STATUSES.includes(String(status || '').toLowerCase())
}

export const isWheel500SpinningStatus = (status) => {
  return String(status || '').toLowerCase() === WHEEL500_SPINNING_STATUS
}
